import React, { FC } from "react";
import { Pagination, Skeleton, Button, Empty } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { AddAccess } from "../../../../components/accessControl/AccessControl";
import ProjectCard from "./ProjectCard";

interface ProjectCardGridProps {
  dataSource: any[];
  loading: boolean;
  pagination: any;
  statusTab: string;
  onOpen: (record: any) => void;
  onPageChange: (page: number, pageSize: number) => void;
  onAddProject: () => void;
}

const SkeletonCard: FC = () => (
  <div className="pms-project-card" style={{ cursor: "default" }}>
    <Skeleton active paragraph={{ rows: 4 }} title={{ width: "60%" }} />
  </div>
);

const ProjectCardGrid: FC<ProjectCardGridProps> = ({
  dataSource,
  loading,
  pagination,
  statusTab,
  onOpen,
  onPageChange,
  onAddProject,
}) => {
  if (loading) {
    return (
      <div className="pms-card-grid">
        {Array.from({ length: 6 }, (_, i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    );
  }

  if (!dataSource?.length) {
    return (
      <div className="pms-hub-empty">
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={`No ${statusTab === "All" ? "" : statusTab + " "}projects`}
        >
          <AddAccess moduleName="Projects">
            <Button type="primary" icon={<PlusOutlined />} onClick={onAddProject}>
              Add Project
            </Button>
          </AddAccess>
        </Empty>
      </div>
    );
  }

  return (
    <>
      <div className="pms-card-grid pms-view-fade">
        {dataSource.map((record: any) => (
          <ProjectCard key={record.uid} record={record} onOpen={onOpen} />
        ))}
      </div>
      <div className="pms-hub-pagination">
        <Pagination
          size="small"
          current={pagination.current}
          pageSize={pagination.pageSize}
          total={pagination.total}
          showSizeChanger={pagination.showSizeChanger}
          pageSizeOptions={pagination.pageSizeOptions}
          onChange={onPageChange}
          showTotal={(t: number) => `Total ${t} projects`}
        />
      </div>
    </>
  );
};

export default ProjectCardGrid;
